import type { SVGProps } from 'react';

export function IconArrowLeft(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12.7959 7.46962C13.0887 7.17667 13.5635 7.17692 13.8564 7.46962C14.1494 7.7624 14.1502 8.23718 13.8574 8.53017L7.14648 15.245H26.667C27.0811 15.245 27.4169 15.5809 27.417 15.995C27.417 16.4092 27.0812 16.745 26.667 16.745H7.13672L13.8574 23.4696C14.1502 23.7626 14.1494 24.2374 13.8564 24.5302C13.5634 24.8227 13.0886 24.8231 12.7959 24.5302L4.80176 16.5302C4.68589 16.4142 4.61689 16.2694 4.59277 16.119C4.58607 16.0787 4.58203 16.0372 4.58203 15.995C4.58207 15.8214 4.64315 15.6631 4.74219 15.536C4.74789 15.5288 4.75376 15.5216 4.75977 15.5145C4.78149 15.4887 4.80413 15.464 4.8291 15.4413L12.7959 7.46962Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
}
